// extracted by mini-css-extract-plugin
export default {"factor-box":"factor_factor-box__dg3VC","container":"factor_container__jY3lF","textDescription":"factor_textDescription__ZPpfS"};